
// src/connects/group-selection-dialog.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import { inject } from '../helpers/context'
import { getArray, mergeArray } from '../helpers/store'
import combineHOC from '../helpers/combine-hoc'
import map from 'lodash/map'
import filter from 'lodash/filter'
import some from 'lodash/some'

export const mapStateToProps = (state)=> {
  let groups = state.groups.items
  if(groups && state.divisions.items && state.divisions.currentId) {
    const divisions = state.divisions.items
    divisions.forEach(division => {
      groups = groups.filter(group => group.is_free_group)
    });
  }

  return {
    groups,
    isFetching: state.account.isFetching,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    willUpdate: (props, nextProps)=> {
      // clear users data when dialog close
      if (props.ui && nextProps.ui && props.ui.active && !nextProps.ui.active) {
        props.updateUI({
          selected: undefined,
          query: undefined,
          search: false,
          mode: undefined,
          group: undefined,
        })
        dispatch(actions.clearFetchedUsers())
      }

      // reload when query change
      if (props.ui && nextProps.ui && nextProps.ui.active && (
        props.ui.group != nextProps.ui.group ||
        props.ui.query != nextProps.ui.query ||
        props.ui.mode != nextProps.ui.mode
      )) {
        dispatch(actions.fetchGroups())
      }
    },

    fetchGroups: (props)=> {
        // do nothing
    },

    onSelect: (props, group)=> {
      !props.ui.multiple && props.ui.callback && props.ui.callback(group)
      props.updateUI({
        selected: mergeArray('group_id', props.ui.selected, [group]),
        active: props.ui.multiple,
      })
    },

    selectAll: (props)=> {
      const visibleGroups = props.ui.query ? props.groups.filter(group => group.name.includes(props.ui.query)) : props.groups
      props.updateUI({
        selected: mergeArray('group_id', [], visibleGroups),
        active: true,
      })
    },

    unselectAll: (props)=> {
      props.updateUI({
        selected: undefined,
        active: true,
      })
    },

    onFinish: (props)=> {
      props.updateUI({ active: false })
      props.ui.callback && props.ui.callback(props.ui.selected)
    },

    showGroupSelectionDialog:
      (title, multiple, mode, selected, callback, props)=> {
        props.updateUI({
          active: true,
          title,
          multiple,
          mode,
          callback,
          selected,
        })
      },
      // title: dialog title
      // multiple: multiple selection or single selection dialog
      // mode: OTHER_GROUPS
      // callback: callback when selected
      // props: will be injected by 'inject'
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({ state: {
    active: false,
    title: undefined,
    multiple: false,
    mode: undefined,
    callback: undefined,
    query: undefined,
    selected: undefined,
    search: false,
  }}),
  translate(),
  lifecycle,
  inject({ showGroupSelectionDialog: PropTypes.func }),
)



// WEBPACK FOOTER //
// ./src/connects/group-selection-dialog.js